import { render, staticRenderFns } from "./product-gallery.vue?vue&type=template&id=2aae5395"
import script from "./product-gallery.vue?vue&type=script&lang=ts"
export * from "./product-gallery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports